import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupEditRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/$id/edit',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    tab: z
      .enum([
        'general',
        'team',
        'tags',
        'crm',
        'password',
        'crm_setting',
        'legal_entity',
        'external_links',
      ])
      .default('general'),
  }),
}).lazy(() => import('pages/group/Edit/GroupEditPage/GroupEditPage').then((d) => d.Route));
